import { registerLocaleData } from '@angular/common';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import localePt from '@angular/common/locales/pt';

import { CalendarioFrequenciaComponent } from './calendario-frequencia/calendario-frequencia.component';

registerLocaleData(localePt);
import { AbonoJustificativaModalComponent } from './abono-justificativa-modal/abono-justificativa-modal.component';
import { MobileFrequenciaAulaComponent } from './mobile-frequencia-aula/mobile-frequencia-aula.component';
import { LucideAngularModule } from 'lucide-angular';
import { PermissionsModule } from '@shared/permissions.module';

@NgModule({
  declarations: [
    CalendarioFrequenciaComponent,
    MobileFrequenciaAulaComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    LucideAngularModule,
    PermissionsModule,
    AbonoJustificativaModalComponent
  ],
  providers: [{ provide: MAT_DATE_LOCALE, useValue: 'pt-BR' }],
  exports: [
    CalendarioFrequenciaComponent,
    AbonoJustificativaModalComponent,
    MobileFrequenciaAulaComponent
  ]
})
export class FrequenciaComponentsModule { }